import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../core/store';
import { selectTimerSeconds, setTimerSeconds } from '../../core/store/app';

export const useInitTimer = (initialMinutes: number) => {
  const stateSeconds = useSelector(selectTimerSeconds);
  const initValue = stateSeconds ?? initialMinutes * 60;
  const dispatch = useAppDispatch();
  const [totalSeconds, setTotalSeconds] = useState<number>(initValue);

  const lastStateValue = useRef(stateSeconds);

  useEffect(() => {
    if (stateSeconds !== null && stateSeconds !== lastStateValue.current) {
      lastStateValue.current = stateSeconds;
      setTotalSeconds(stateSeconds);
    }
  }, [stateSeconds]);

  useEffect(() => {
    const interval = setInterval(() => {
      setTotalSeconds((prevTotalSeconds) => {
        if (prevTotalSeconds > 0) {
          return prevTotalSeconds - 1;
        }
        return 0;
      });
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    dispatch(setTimerSeconds(totalSeconds));
  }, [totalSeconds, dispatch]);

  useEffect(() => {
    return () => {
      dispatch(setTimerSeconds(null));
    };
  }, [dispatch]);
};

export const useTimer = () => {
  const totalSeconds = useSelector(selectTimerSeconds) || 0;
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  return { minutes, seconds };
};

export const useResetTimer = (initialMinutes: number) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setTimerSeconds(initialMinutes * 60));
  }, [dispatch, initialMinutes]);
};

export const formatNumber = (value: number | string): string => value.toString().padStart(2, '0');
